var GalleryView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

GalleryView = (function() {
  function GalleryView(gallery, options) {
    this.gallery = gallery;
    this.load = __bind(this.load, this);
    this.refresh = __bind(this.refresh, this);
    this.move = __bind(this.move, this);
    Observable(this, 'loaded', null);
  }

  GalleryView.prototype.move = function(element) {
    var gallery, to;
    gallery = element.item;
    to = element.targetIndex;
    return gallery.update({
      sort: to
    });
  };

  GalleryView.prototype.refresh = function(type) {
    this.loaded(null);
    return this.load(type);
  };

  GalleryView.prototype.load = function() {
    return this.loaded(Gallery(this.gallery));
  };

  return GalleryView;

})();

//# sourceMappingURL=galleries.js.map
